import { Storage } from '@aytm/lib/storage'
import railsPostFetch from '@aytm/lib/common/rails-post-fetch'

export const wrappedPostFetch = (url, data = {}) =>
  Storage.Encode(data)
    .then(_bsfz =>
      railsPostFetch(url, {
        body: JSON.stringify({ _bsfz })
      })
    )
    .then(response => response.json())
